var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysMandatoryFields = function SvgSysMandatoryFields(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.455 19a.02.02 0 0 0-.01 0l-.037-.006h-.007a.51.51 0 0 1-.214-.1.48.48 0 0 1-.064-.064l-1.976-1.974a.502.502 0 0 1 .357-.84.501.501 0 0 1 .349.132l1.607 1.6 3.649-4.56a.5.5 0 0 1 .783.622l-4 5a.191.191 0 0 1-.023.026.031.031 0 0 1-.008.01l-.009.01-.022.017-.012.012-.029.021-.014.01-.027.016a.086.086 0 0 1-.02.01l-.02.01-.027.013a.086.086 0 0 0-.02.008l-.02.006-.032.007h-.015a.125.125 0 0 1-.046.006h-.043l-.05.008ZM3.5 18a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1h-8Zm0-6a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1h-13Zm0-6a.5.5 0 0 1 0-1h17a.5.5 0 0 1 0 1h-17Z"
  })));
};
export default SvgSysMandatoryFields;